import avatar from "../../../assets/profile5.png";
import {STORAGE_URL} from "../../../config";
import Helper from "../../../Helper";
import React from "react";

export const UserInfo = ({
                             employer,
                             createUpdateProfile,
                             handleProfileClick
                         })=>{
    // Get current logged-in user ID
    const currentUserId = localStorage.getItem('userId');
    
    // Filter users to show only the current logged-in user
    const currentUser = employer?.employer_data?.users?.find(user => 
        user.id === parseInt(currentUserId)
    ) || employer?.employer_data?.users?.[0]; // Fallback to first user if current user not found
    
    //Location code
    const generateNonUsLocation = () => {
        const country = employer?.employer_data?.country?.name || '';
        const state = employer?.employer_data?.state || '';
        const city = employer?.employer_data?.city || '';

        const locationParts = [country];
        if (state) {
            locationParts.push(state);
        }
        if (city) {
            locationParts.push(city);
        }

        return locationParts.join(', ');
    };

    return(
        <div className="analytics-rd">
            {employer &&
            employer?.employer_data &&
            employer.employer_data.users &&
            employer.employer_data.users.length > 0 &&
            !currentUser?.firstname && !currentUser?.lastname ? (
                <div className="activejob-rdtxt">
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={avatar}
                            alt="User"
                            style={{
                                width: "50px",
                                height: "50px",
                                marginRight: "10px",
                                marginBottom: "10px",
                            }}
                        />
                        <h6>Complete your profile for better job prospects</h6>
                    </div>
                    <br />
                    <button
                        className="btn btn-success w-100 d-block"
                        onClick={createUpdateProfile}
                    >
                        Complete Profile
                    </button>
                </div>
            ) : (
                <div>
                    {currentUser && (
                        <div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <img
                                    className="profile-image"
                                    src={
                                        currentUser.current_employee_logo
                                            ? `${STORAGE_URL}${currentUser.current_employee_logo}`
                                            : avatar
                                    }
                                />
                                <h2 className="EDcompanytxt">
                                    {currentUser.current_employee}

                                </h2>
                            </div>
                             <p className="EDtext">
                                    <span >Address:</span>{" "}
                                    {/*{"257 Fireweed Ln, Ketchikan, AK 99901, USA"}*/}
                                    {employer?.employer_data?.us_based === 'yes' ?employer?.employer_data?.location : generateNonUsLocation() }
                                </p>





                            {employer?.employer_data?.subscription?.start_date &&(
                            <p className="EDtext">
                                <span>Membership Start: </span>{" "}
                                {Helper.changeDateFormat(employer?.employer_data?.subscription?.start_date)}
                            </p>
                            )}
                            {employer?.employer_data?.subscription?.end_date &&(
                            <p className="EDtext">
                                <span>Membership End: </span>{" "}
                                {(() => {
                                    const startDate = new Date(employer?.employer_data?.subscription?.end_date);
                                    const endDate = new Date(startDate);
                                    endDate.setDate(startDate.getDate() + 30);
                                    // return 'July 4, 2024';
                                    return Helper.changeDateFormat(employer?.employer_data?.subscription?.end_date)
                                })()}
                            </p>
                            )}
                            {employer?.employer_data?.subscription?.package?.name &&(
                            <p className="EDtext">
                                <span>Subscription Level: </span>{" "}
                                {employer?.employer_data?.subscription?.package?.name}
                            </p>
                            )}
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <img
                                    className="profile-image"
                                    src={
                                        currentUser.image
                                            ? `${STORAGE_URL}${currentUser.image}`
                                            : avatar
                                    }
                                />
                                <h2 className="EDcompanytxt"
                                    onClick={handleProfileClick} >
                                    {currentUser.firstname || ""} {currentUser.lastname || ""}
                                </h2>
                            </div>

                        </div>
                    )}
                </div>
            )}
        </div>
    )
}